import { render, staticRenderFns } from "./salesChart.vue?vue&type=template&id=dfd929a0&scoped=true&"
import script from "./salesChart.vue?vue&type=script&lang=js&"
export * from "./salesChart.vue?vue&type=script&lang=js&"
import style0 from "./salesChart.vue?vue&type=style&index=0&id=dfd929a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd929a0",
  null
  
)

export default component.exports